import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5bedda74"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["textContent"]
const _hoisted_2 = { class: "list" }
const _hoisted_3 = { class: "tail" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_OfferOverviewSingle = _resolveComponent("OfferOverviewSingle")!
  const _component_SvgIcon = _resolveComponent("SvgIcon")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["wrapper", {'--privilege' : $props.isPrivilege}])
  }, [
    _createElementVNode("h1", {
      class: "title",
      textContent: _toDisplayString($setup.title)
    }, null, 8, _hoisted_1),
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.list, (offer, i) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "list-item",
          key: i
        }, [
          _createVNode(_component_OfferOverviewSingle, {
            item: offer,
            link: $setup.link
          }, null, 8, ["item", "link"])
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createVNode(_component_router_link, {
        to: {
        name: 'List',
        params: {
          category: $setup.link
        }
      },
        class: "link"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", null, _toDisplayString(_ctx.$t('see-all')), 1),
          _createVNode(_component_SvgIcon, {
            class: "arrow-right",
            "icon-name": "arrow-right"
          })
        ]),
        _: 1
      }, 8, ["to"])
    ])
  ], 2))
}